import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type CellContext } from '@tanstack/react-table';
import { useIntl } from 'react-intl';

import { parkingManagementMessages } from 'src/features/parkingManagement/utils';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/utils/messages';

import type { Notification } from 'src/features/parkingManagement/types/notifications';

interface CellNotificationsActionsProps<TData, TValue> extends CellContext<TData, TValue> {
    notificationCallBack: (point: TData) => void;
}
function CellNotificationsActions({ notificationCallBack, row }: CellNotificationsActionsProps<Notification, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="ml-auto flex max-w-24 gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button onClick={() => notificationCallBack(row.original)} size="icon" variant="link">
                            <FontAwesomeIcon icon={faEdit} />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        {`${formatMessage(generalMessages.edit)} ${formatMessage(parkingManagementMessages.notification).toLocaleLowerCase()}`}
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}

export { CellNotificationsActions };
